import React, { createContext, useContext, useState, useEffect } from 'react';

const NetworkStatusContext = createContext();

function NetworkStatusProvider({ children }) {
  const [isOnline, setIsOnline] = useState(true);
  const linkUrl = 'https://www.google.com';

  const handleCheckInternet = () => {
    const status = fetch(linkUrl, { mode: 'no-cors' })
      .then(() => {
        return true;
      })
      .catch(() => {
        setIsOnline(false);
        return false;
      });

    return status;
  };

  useEffect(() => {
    if (isOnline) {
      const interval = setInterval(() => {
        handleCheckInternet();
      }, 5000);

      return () => clearInterval(interval);
    }
  }, [isOnline]);

  return (
    <NetworkStatusContext.Provider value={{ isOnline, handleCheckInternet }}>
      {children}
    </NetworkStatusContext.Provider>
  );
}

function useNetworkStatusProvider() {
  const context = useContext(NetworkStatusContext);
  if (context === undefined) {
    throw new Error('useNetworkStatusProvider must be used within NetworkStatusProvider');
  }
  return context;
}

export { useNetworkStatusProvider };
export default NetworkStatusProvider;
